// @flow

import React from 'react';
import { Translate } from 'react-redux-i18n';
import flowApi from '../../../../../network/api/flowApi';
import { getR12MonthYear } from '../../../../../utils/dateUtils';
import { getCurrentPcId } from '../../../../../utils/urlUtils';
import { autoQuantityStr } from '../../../../../utils/formatUtils';
import type { KeyFigure } from '../../../../../types/FlowType';
import type { FootFallDoors } from '../../../../../types/geminiType';
import MarketingFact from '../../../data/marketing/MarketingFact';
import timeIcon from '../../../../../img/marketingIcon/sc_ma_visit-time.png';
import metroSteps from '../../../../../img/marketingIcon/metro-steps.png';

type Props = {
  footfallDataList: FootFallDoors[],
}

type State = {
  keyFigure: KeyFigure,
}

class KeyFigures extends React.Component<Props, State> {
  state: State = {
    keyFigure: null,
  };

  componentDidMount() {
    flowApi.fetchKeyFigure(getCurrentPcId())
      .then(result => result.json())
      .then(json => this.setState({ keyFigure: json }));
  }

  render() {
    const r12m = this.props.footfallDataList
      .map(footfallData => footfallData.entrances)
      .reduce((a, b) => a + b, 0);

    const currentMonth = this.props.footfallDataList
      .map(footfallData => footfallData.entrancesCurrentMonth)
      .reduce((a, b) => a + b, 0);

    const r12mLastYear = this.props.footfallDataList
      .map(footfallData => footfallData.entrancesLastYear)
      .reduce((a, b) => a + b, 0);

    const prevMonth = this.props.footfallDataList
      .map(footfallData => footfallData.entrancesPrevMonth)
      .reduce((a, b) => a + b, 0);

    const diffR12M = (r12mLastYear) !== 0 ? (((r12m - r12mLastYear) * 100) / r12mLastYear) : 0;
    const diffMonth = (prevMonth) !== 0 ? (((currentMonth - prevMonth) * 100) / prevMonth) : 0;
    return (
      <div>
        <div className="title">
          <Translate value="flow.keyFigure.title" />
        </div>
        <div className="facts">
          <MarketingFact
            image={timeIcon}
            value={this.state.keyFigure && `${Math.round(this.state.keyFigure.dwellTime)} min`}
            label={<Translate value="flow.keyFigure.dwellTime" />}
          />
          {
            this.props.footfallDataList.length > 0 && (
              <>
                <MarketingFact
                  image={metroSteps}
                  value={
                    this.props.footfallDataList &&
                    autoQuantityStr(r12m)}
                  label={<Translate value="flow.keyFigure.footfall" />}
                  subValueClassName={diffR12M > 0 ? 'green' : 'red'}
                  subValue={`(${diffR12M.toFixed(2)}%)`}
                  subTitle={`R12M ${new Date().getFullYear()}`}
                />
                <MarketingFact
                  image={metroSteps}
                  value={
                    this.props.footfallDataList &&
                    autoQuantityStr(currentMonth)}
                  label={<Translate value="flow.keyFigure.footfall" />}
                  subValueClassName={diffMonth > 0 ? 'green' : 'red'}
                  subValue={`(${diffMonth > 0 ? '+' : ''}${diffMonth.toFixed(2)}%)`}
                  subTitle={getR12MonthYear()}
                />
              </>
            )
          }
        </div>
      </div>
    );
  }
}

export default KeyFigures;
